
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_API_URL;

// ==================== GeoResolver Main ====================

export const AddGeoResolverMain = createAsyncThunk(
    'georesolver/AddGeoResolverMain',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/GeoResolverMain_add`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to add GeoResolver Main');
        }
    }
);

export const fetchGeoResolverMain = createAsyncThunk(
    'georesolver/fetchGeoResolverMain',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverMain_view`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch GeoResolver Main');
        }
    }
);

export const UpdateGeoResolverMain = createAsyncThunk(
    'georesolver/UpdateGeoResolverMain',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/GeoResolverMain_update/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update GeoResolver Main');
        }
    }
);

export const DeleteGeoResolverMain = createAsyncThunk(
    'georesolver/DeleteGeoResolverMain',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverMain_delete/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to delete GeoResolver Main');
        }
    }
);

// ==================== GeoResolver Detail ====================

export const AddGeoResolverDetail = createAsyncThunk(
    'georesolver/AddGeoResolverDetail',
    async ({ selectedId, values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/GeoResolverDetail_add/${selectedId}`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to add GeoResolver Detail');
        }
    }
);

export const fetchGeoResolverDetail = createAsyncThunk(
    'georesolver/fetchGeoResolverDetail',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverDetail_view`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch GeoResolver Detail');
        }
    }
);

export const UpdateGeoResolverDetail = createAsyncThunk(
    'georesolver/UpdateGeoResolverDetail',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/GeoResolverDetail_update/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update GeoResolver Detail');
        }
    }
);

export const DeleteGeoResolverDetail = createAsyncThunk(
    'georesolver/DeleteGeoResolverDetail',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverDetail_delete/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to delete GeoResolver Detail');
        }
    }
);

// ==================== GeoResolver Registration ====================

export const AddGeoResolverRegistration = createAsyncThunk(
    'georesolver/AddGeoResolverRegistration',
    async ({ clientId, values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/GeoResolverRegistration_add/${clientId}`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to add GeoResolver Registration');
        }
    }
);

export const fetchGeoResolverRegistration = createAsyncThunk(
    'georesolver/fetchGeoResolverRegistration',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverRegistration_view`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch GeoResolver Registration');
        }
    }
);

export const UpdateGeoResolverRegistration = createAsyncThunk(
    'georesolver/UpdateGeoResolverRegistration',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/GeoResolverRegistration_update/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update GeoResolver Registration');
        }
    }
);

export const DeleteGeoResolverRegistration = createAsyncThunk(
    'georesolver/DeleteGeoResolverRegistration',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GeoResolverRegistration_delete/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to delete GeoResolver Registration');
        }
    }
);

// ==================== Slice ====================

const GeoResolverSlice = createSlice({
    name: 'georesolver',
    initialState: {
        // GeoResolver Main
        GeoResolverMainData: [],
        GeoResolverMainLoading: false,
        GeoResolverMainError: null,

        // GeoResolver Detail
        GeoResolverDetailData: [],
        GeoResolverDetailLoading: false,
        GeoResolverDetailError: null,

        // GeoResolver Registration
        GeoResolverRegistrationData: [],
        GeoResolverRegistrationLoading: false,
        GeoResolverRegistrationError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ---- Fetch GeoResolver Main ----
            .addCase(fetchGeoResolverMain.pending, (state) => { state.GeoResolverMainLoading = true; state.GeoResolverMainError = null; })
            .addCase(fetchGeoResolverMain.fulfilled, (state, action) => { state.GeoResolverMainLoading = false; state.GeoResolverMainData = action.payload; })
            .addCase(fetchGeoResolverMain.rejected, (state, action) => { state.GeoResolverMainLoading = false; state.GeoResolverMainError = action.payload; })

            // ---- Fetch GeoResolver Detail ----
            .addCase(fetchGeoResolverDetail.pending, (state) => { state.GeoResolverDetailLoading = true; state.GeoResolverDetailError = null; })
            .addCase(fetchGeoResolverDetail.fulfilled, (state, action) => { state.GeoResolverDetailLoading = false; state.GeoResolverDetailData = action.payload; })
            .addCase(fetchGeoResolverDetail.rejected, (state, action) => { state.GeoResolverDetailLoading = false; state.GeoResolverDetailError = action.payload; })

            // ---- Fetch GeoResolver Registration ----
            .addCase(fetchGeoResolverRegistration.pending, (state) => { state.GeoResolverRegistrationLoading = true; state.GeoResolverRegistrationError = null; })
            .addCase(fetchGeoResolverRegistration.fulfilled, (state, action) => { state.GeoResolverRegistrationLoading = false; state.GeoResolverRegistrationData = action.payload; })
            .addCase(fetchGeoResolverRegistration.rejected, (state, action) => { state.GeoResolverRegistrationLoading = false; state.GeoResolverRegistrationError = action.payload; })
    }
});

export default GeoResolverSlice.reducer;
